<script lang="ts">
    import {enhance} from "$app/forms";
    import {page} from "$app/stores";
    import type {Address, Employee} from "$lib/types/employee";
    import CardLayout from "$items/CardLayout.svelte";
    import InfoBox from "$items/InfoBox.svelte";
    import type {Writable} from "svelte/store";
    import {getContext} from "svelte";
    import ApplyTrigger from "$items/employee/ApplyTrigger.svelte";
    import {Button, Hr, Input, Label} from "flowbite-svelte";
    import {
        EnvelopeOpenSolid,
        MobilePhoneSolid,
        HomeSolid,
        FacebookSolid, PenOutline, CheckCircleSolid, ExclamationCircleOutline, MailBoxSolid

    } from "flowbite-svelte-icons";
    import CardLayoutSubmitButton from "$items/employee/form/CardLayoutSubmitButton.svelte";
    import IncompleteDataWarning from "$lib/components/IncompleteDataWarning.svelte";

    export let employee: Employee = $page.data.employee;
    let super_edit: Writable<boolean> = getContext('super_edit');

    let loading = false;

    $: complete = addressComplete(employee.address) && employee.mobile && employee.email

    function addressComplete(address: Address){
        if(!address){
            return false
        }
        return !(!address.country || !address.zip || !address.number || !address.street || !address.place || !address.country);

    }
</script>

<CardLayout title="Kontakt">
    <svelte:fragment slot="card-header">
        <IncompleteDataWarning {complete}/>
    </svelte:fragment>

    <form class="flex flex-col gap-3" method="post"
          class:opacity-20={loading}
          action="?/update_employee"
          use:enhance={() => {loading=true;return ({ update }) => {loading=false; update({ reset: false })}}}>
        <div class="flex flex-col gap-1 px-4">

            <InfoBox
                    icon={MobilePhoneSolid}
                    value={employee.mobile} name="mobile"
                    link={employee.mobile ? `tel:${employee.mobile}` : null}>
            </InfoBox>
            <InfoBox
                    icon={EnvelopeOpenSolid}
                    type="email"
                    link="mailto:{employee.email}"
                    value={employee.email || ''} name="email">
            </InfoBox>
        </div>
        <div class="my-2 border-b border-dotted"/>
        <div class="flex flex-col gap-1 px-4">
            <InfoBox link="https://www.facebook.com" icon={FacebookSolid} value={employee.cv?.facebook || ''}></InfoBox>
            <InfoBox link="https://www.instagram.com" icon='ri:instagram-fill' value={employee.cv?.instagram || ''}></InfoBox>
        </div>

        <div class="my-2 border-b border-dotted"/>

        <div class="flex flex-col gap-1 px-4 ">
            <InfoBox icon={HomeSolid} value={employee.address?.name || ''} placeholder="Name d. Adresse" name="address_name"/>
            <InfoBox icon={MailBoxSolid} value={employee.address?.addressAddendum || ''} placeholder="Adresszusatz" name="address_addressAddendum"/>

            <div class="flex gap-x-2">
                <InfoBox class="pl-7" value={employee.address?.street || ''} placeholder="Straße" name="address_street"></InfoBox>
                <div class="flex-1">
                    <InfoBox displayClass="!pl-1" value={employee.address?.number || ''} placeholder="Hausnummer" name="address_number"></InfoBox>
                </div>

            </div>
            <div class="grid grid-cols-3 gap-x-2 ">
                <InfoBox class="pl-7" value={employee.address?.zip || ''} placeholder="PLZ" name="address_zip"></InfoBox>
                <div class="col-span-2">
                    <InfoBox displayClass="!pl-1" value={employee.address?.place  || ''} placeholder="Ort" name="address_place"></InfoBox>
                </div>
            </div>
            <InfoBox class="pl-7" value={employee.address?.country  || ''} placeholder="Land" name="address_country"></InfoBox>
            <CardLayoutSubmitButton/>
            <ApplyTrigger {loading}/>
        </div>
        {#if employee.address}
        <div class="flex flex-col gap-2 px-4 py-2">

                <iframe title="Map" class="col-span-2" width="100%" height="100%" id="gmap_canvas"
                        src={`https://maps.google.com/maps?q=${employee.address.street.replace(/\s/, '%20')}%20${employee.address.number}%20${employee.address.place}%20${employee.address.country}&t=&z=15&ie=UTF8&iwloc=&output=embed`}
                        frameborder="0" scrolling="no" marginheight="0" marginwidth="0">
                </iframe>

        </div>
        {/if}
    </form>
</CardLayout>